import moment from "moment";
import dateAvailability from "./dateAvailability";

function mediaTypeName(inventoryLike) {
  return (
    inventoryLike?.typeOfMedia?.name ??
    inventoryLike?.mediaVehicle ??
    ""
  );
}

function isLedMedia(inventoryLike) {
  return String(mediaTypeName(inventoryLike)).trim().toLowerCase() === "led";
}

/**
 * Proposal Excel/PPT + modal: same merged availability as inventory cart exports
 * (Bookings, blockedDates, FOC, rotational, premium, linked half/full).
 */
export default function getProposalAvailableFromLabel(inventoryLike) {
  if (!inventoryLike) return "-";
  if (isLedMedia(inventoryLike)) return "Immediate";
  const info = dateAvailability(
    inventoryLike?.Bookings,
    false,
    inventoryLike,
  );
  if (info?.status === "IMMEDIATE") return "Immediate";
  if (info?.nextAvailableDate) {
    return moment(info.nextAvailableDate).format("DD-MM-YYYY");
  }
  return "-";
}

/**
 * Non-LED inventories whose computed Available From is Immediate (proposal → cart for blocking).
 */
export function isImmediateNonLedForBlockCart(inv) {
  if (!inv) return false;
  if (isLedMedia(inv)) return false;
  return getProposalAvailableFromLabel(inv) === "Immediate";
}
